export const getNumberWithUnit = (number) => {
  if (number >= 1e3) {
    var units = ["K", "M", "B", "T", "QD", "QT", "ST", "SP"];
    let unit = Math.floor((number.toFixed(0).length - 1) / 3) * 3;
    var num = (number / ("1e" + unit)).toFixed(2);
    var unitName = units[Math.floor(unit / 3) - 1];
    if (number > 1000000) {
      return "$" + num + unitName;
    } else {
      return "< $10M"
    }
  }
  return number;
};
